export const AUDIT_LOGS_REDUCER_NAME = 'auditLogs'

export const LOGS_PER_PAGE = 20

export enum AUDIT_HEADERS {
  DATE = 'date',
  DOMAIN = 'domain',
  USER = 'user',
  ACTION = 'action',
}
